import { createFileRoute } from "@tanstack/react-router";
import { SignedOutPage } from "../features/auth/signed-out-page";

export const Route = createFileRoute("/signed-out")({ component: SignedOutPage });
